import React from 'react';

export default function OrderTracking() {
  return <div className="order-tracking"><h1>Order Tracking</h1></div>;
}
